import { defineStore } from "pinia";
import { Creature } from "../game/classes/Creature.js";
import { Weapon } from "../game/classes/Weapon.js";
import { Materials } from "../game/data/materials.js";
import { Monsters, Zones } from "../game/data/monsters.js";
import { WeaponSubtypes } from "../game/data/weaponSubtypes.js";

export const useGameStore = defineStore("game", {
  state: () => ({
    player: null,
    enemy: null,
    currentMonster: null,
    currentZone: "OUTSKIRTS",
    isFighting: false,
    isPaused: false,
    isSimulating: false,
    isRespawning: false,
    respawnTimer: 0,
    respawnTime: 180,
    fightLog: [],
  }),
  actions: {
    initPlayer() {
      const weapon = Weapon.create(WeaponSubtypes.SHORTSWORD, Materials.IRON, {
        damage: 3,
        attackSpeed: 3,
        lifesteal: 3,
      });
      this.player = new Creature("Player", 100, weapon, 0, true);
    },
    spawnEnemy() {
      const zone = Zones[this.currentZone];
      const monsterKeys = zone.monsters;
      const randomKey =
        monsterKeys[Math.floor(Math.random() * monsterKeys.length)];
      this.currentMonster = Monsters[randomKey];
      this.enemy = Creature.createMonster(this.currentMonster);
    },
    setZone(zoneName) {
      this.currentZone = zoneName;
    },
    startFight() {
      if (!this.player) this.initPlayer();
      this.spawnEnemy();
      this.isFighting = true;
      this.player.resetCombat();
      this.enemy.resetTimers();
    },
    stopFight() {
      this.isFighting = false;
    },
    togglePause() {
      this.isPaused = !this.isPaused;
    },
    respawnPlayer() {
      this.isRespawning = true;
      this.respawnTimer = 0;
    },
    finishRespawn() {
      this.isRespawning = false;
      this.player.health = 100;
      this.player.currentAmmo = this.player.weapon.magazineSize || 0;
      this.fightLog = [];
      this.startFight();
    },
    equipWeapon(weapon) {
      this.player.weapon = weapon;
      this.player.armor = weapon.armor || 0;
      this.player.currentAmmo = weapon.magazineSize || 0;
    },
  },
});
